import axios from "axios";
import qs from "qs";

import { api } from "@/plugins/util";

/**
 * 搜索文章
 * @param title         标题
 * @param publishFlag   状态
 * @param articleType 文章类型
 * @param pageNum       页数
 * @param pageSize      每页显示数量
 * @returns {AxiosPromise<any>}
 */
export function search({
                           title,
                           publishFlag,
                           articleType,
                           pageNum,
                           pageSize
                       }) {
    return axios.get(api + "/article/search", {
        params: {
            title,
            publishFlag,
            articleType,
            pageNum,
            pageSize
        }
    })
}


/**
 * 发布动态消息
 * @param title         文章标题
 * @param author        作者
 * @param content       内容
 * @param publishFlag   发布标志位
 * @returns {AxiosPromise<any>}
 */
export function publishArticle({
                                   id,
                                   title,
                                   author,
                                   content,
                                   publishFlag
                               }) {
    return axios.post(api + "/article/insert", {
        title,
        author,
        content,
        publishFlag
    })
}

/**
 * 保存文章
 * @param id            文章主键
 * @param title         文章标题
 * @param author        文章作者
 * @param content       文章内容
 * @param publishFlag   发布标志位
 * @returns {AxiosPromise<any>}
 */
export function saveArticle({
                                id,
                                title,
                                author,
                                content,
                                publishFlag,
                                coverImg,
                                articleType,
                                files,
                            }) {
    return axios.post(api + "/article/save", {
        id,
        title,
        author,
        content,
        publishFlag,
        coverImg,
        articleType,
        files,
    })
}

export function uploadFile(formData) {
    return axios({
        url: api + "/zdcp/upload",
        method: "post",
        data: formData,
        headers: { "Content-Type": "application/x-www-form-urlencoded" }
    });
}

/**
 * 查找单片文章内容
 * @param id 文章主键
 * @returns {AxiosPromise<any>}
 */
export function findById(id) {
    return axios.get(api + "/article/findById?id=" + id)
}

/**
 * 删除文章
 * @param id 文章主键
 * @returns {AxiosPromise<any>}
 */
export function deleteArticle(id) {
    return axios.get(api + "/article/delete", {
        params: {
            id
        }
    })
}

/**
 * 发布文章、停用文章
 * @param id 文章主键
 * @returns {AxiosPromise<any>}
 */
export function reserve(id) {
    return axios.get(api + "/article/publish", {
        params: {
            id
        }
    })
}

/**
 * 获取最新的count篇文章
 * @param count 条数
 * @returns {AxiosPromise<any>}
 */
export function findByCount(count,type) {
    return axios.get(api + "/article/getByCount", {
        params: {
            count,
            type,
        }
    })
}

/**
 * 查询新闻
 * @returns {AxiosPromise<any>}
 */
export function findNews(conditions) {
    return axios.post(api + "/article/findNews", conditions);
}

/**
 *动态信息，根据文章类型获取列表
 */
export function getList(
                            type
                        ) {
    return axios.get(api + "/article/list", {
        params: {
                type
        }
    });
}
